import { render, staticRenderFns } from "./NoticeService.vue?vue&type=template&id=5ee540c4"
import script from "./NoticeService.vue?vue&type=script&lang=js"
export * from "./NoticeService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports